import React, { useEffect, useMemo, useState } from "react";
import { MdClear } from "react-icons/md";
import { AiOutlineSearch } from "react-icons/ai";

import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {
  Box,
  Checkbox,
  Chip,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputAdornment,
  ListItemIcon,
  TextField,
  Typography
} from "@mui/material";
import { RiSearch2Line } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { findcountryMasterAddAction } from "../../actions/countryMasterAction";
import { allRoleFindAction } from "../../actions/roleMangmentAction";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker, Space } from "antd";
import DeferralFilter from "./DeferralFilter"
const { RangePicker } = DatePicker;

function LeadsFilterSearch(props) {
  const { data, LeadFilterFunction, component, statusComponent } = props
    
  const dispatch = useDispatch();
  
  const [open, setOpen] = useState(false);
  const [secListopen, setSecListOpen] = useState(false);
  const [thirdListopen, setThirdListOpen] = useState(false);
  const [fourthListopen, setFourthListOpen] = useState(false);
  const [fifthListopen, setFifthListOpen] = useState(false);
  const [sixthListopen, setSixthListOpen] = useState(false);
  const [sevenListopen, setseventhListOpen] = useState(false);
  const [eightListopen, seteightListOpen] = useState(false);
  const [ninthListopen, setninthListOpen] = useState(false);
  const [universityOpen, setUniversityOpen] = useState(false);
  const [cityFind, setCityFind] = useState("");
  const [roleList, setRoleList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [selectedRole, setSelectedRole] = useState([])
  const [filterCityOpen, setFilterCityOpen] = useState(false)
  const [city, setCity] = useState([])
  const [feeOpen, setFeeOpen] = useState(false)
  const [openRecalledPaymentDate, setOpenRecalledPaymentDate] = useState(false)
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState([])
  const [selectedPreferedCountries, setSelectedPreferedCountries] = useState([])
  const [selectedApplicationStatus, setSelectedApplicationStatus] = useState([])
  const [selectedUniversity, setSelectedUniversity] = useState([])
  const [selectedLeadStatus, setSelectedLeadStatus] = useState([])
  const [selectedLeadSource, setSelectedLeadSource] = useState([])
  const [selectedBranch, setSelectedBranch] = useState([])
  const [selectedTag, setSelectedTag] = useState([])
  const [selectedPaymentStaus, setSelectedDealPaymentStatus] = useState([])
  const [selectedRegFee, setSelectedRegFee] = useState("");
  const [employeeStatus, setEmployeeStatus] = useState("")
  const [intakeMonth, setIntakeMonth] = useState('')  
  const [intakeYear, setIntakeYear] = useState(null)
  const [intakeYearFilter, setIntakeYearFilter] = useState('')
  const [recalledStatusChangeDate, setRecalledStatusChangeDate] = useState([])
  const [dealsPaymentStatus] = useState(["deposite", "completed", "Refunded"]);
  
  let { countryFindSuccess } = useSelector((state) => {
    return state.findcountryMasterAdd;
  });

  const { allRoleFindSuccess } = useSelector((state) => {
    return state.allRoleFind;
  });

  useEffect(() => {
    dispatch(findcountryMasterAddAction());
  }, [dispatch]);

  useEffect(() => {
    dispatch(allRoleFindAction());
  }, [dispatch]);

  useEffect(() => {
    if (countryFindSuccess) {
      setCountryList(countryFindSuccess);
    }
  }, [countryFindSuccess]);

  useEffect(() => {
    const body = {
      leadCity: selectedCountries,
      preferedCountry: selectedPreferedCountries,
      leadStatus: selectedLeadStatus ,
      leadSource: selectedLeadSource,
      leadBranch: selectedBranch,
      leadTag: selectedTag,
      registrationFeeStatus: selectedRegFee === "Paid" ? "Approved" : selectedRegFee === "Unpaid" ? "Rejected" : "",
      employeeStatus: employeeStatus,
      employeeRole: selectedRole,
      employeeBranch: selectedBranch,
      allApplicationStatus: selectedApplicationStatus,
      allApplicationUniversity: selectedUniversity,
      applicationIntakeMonth: intakeMonth,
      applicationIntakeYear: intakeYearFilter,
      applicationPaymentStatus: selectedPaymentStatus,
      recalledStatusChangeDate: recalledStatusChangeDate,
      dealPaymentStatus: selectedPaymentStaus
    }
    LeadFilterFunction(body)
  }, 
  [
    selectedCountries,
    selectedPreferedCountries,
    selectedLeadStatus,
    selectedLeadSource,
    selectedBranch,
    selectedTag,
    selectedRegFee,
    employeeStatus,
    selectedRole,
    selectedBranch,
    selectedApplicationStatus,
    selectedUniversity,
    intakeMonth,
    intakeYear,
    selectedPaymentStatus,
    recalledStatusChangeDate,
    selectedPaymentStaus
  ])

  useEffect (() => {
    setCity(uniqueSymbolArray)
  }, [data])

  const uniqueSymbolArray = useMemo(() => {
    const seen = new Set();
    return data?.filter((item) => {
      if (!item?.livingCity || item?.livingCity?.trim() === "") return false;
      if (seen.has(item?.livingCity)) return false;
      seen.add(item?.livingCity);
      return true;
    });
  }, [data]);    

  const handleSubmit = (e, chipName) => {
    e.preventDefault();
    // dispatch(city(cityFind, id, "cityFind"));
    props.LeadFilterFunction(cityFind, chipName);
    setCityFind("");
    // Add your logic here to handle the form submission with the entered application fee
  };

  // const handleMonthFilter = (data, chipName) => {
  //   props.LeadFilterFunction(data, chipName)
  // };

  const handleMonthFilter = (data) => {
      const date = new Date(data)
      const monthName = date.toLocaleDateString('default', { month: 'long' })
      setIntakeMonth(monthName)
  }

  const handleYearFilter = (data) => {
    if (data) {
      const yearOnly = new Date(data).getFullYear();
      setIntakeYear(data);
      setIntakeYearFilter(yearOnly)
    }
  }

  // const handleYearFilter = (data, chipName) => {
  //   const date = new Date(data);
  //   const yearOnly = date.getFullYear();    
  //   props.LeadFilterFunction(data, chipName);
  // };

  const handleClick = () => {
    setOpen(!open);
  };
  const handleClick2 = () => {
    setSecListOpen(!secListopen);
  };
  const handleClick3 = () => {
    setThirdListOpen(!thirdListopen);
  };
  const handleUniversityOpen = () => {
    setUniversityOpen(!universityOpen)
  }
  const handleClick4 = () => {
    setFourthListOpen(!fourthListopen);
  };
  const handleClick5 = () => {
    setFifthListOpen(!fifthListopen);
  };
  const handleClick6 = () => {
    setSixthListOpen(!sixthListopen);
  };
  const handleClick7 = () => {
    setseventhListOpen(!sevenListopen);
  };
  const handleClick8 = () => {
    seteightListOpen(!eightListopen);
  };

  const handleClick9 = () => {
    setninthListOpen(!ninthListopen);
  };
  const handleClickCity = () => {
    setFilterCityOpen(!filterCityOpen)
  }

  const handleClickRefistrationFee = () => {
    setFeeOpen(!feeOpen)
  }

  const handleClickRecalledPaymentStatus = () => {
    setOpenRecalledPaymentDate(!openRecalledPaymentDate)
  }

  const handleClearClick = () => {
    // setSelectedDate(e.target.value);
    // setCityFind("");
    // props.handleResetData(true);
    // setSelectedItem("");
    // setSource([]);
    // setBranch([]);
    // setStatus([]);
    // setOpen(!open);
    // setSecListOpen(false);
    // setThirdListOpen(false);
    // setFourthListOpen(false);
    // setFifthListOpen(false);
    // setSixthListOpen(false);
    // setseventhListOpen(false);
    // seteightListOpen(false);
    // setninthListOpen(false);
    setSelectedCountries([])
    setSelectedPreferedCountries([])
    setSelectedLeadStatus([])
    setSelectedLeadSource([])
    setSelectedBranch([])
    setSelectedTag([])
    setSelectedRegFee('')
    setRecalledStatusChangeDate([])
    setIntakeMonth('')
    setIntakeYearFilter('')
  };

  const handleChange = (e) => {
    const searchText = e.target.value.toLowerCase();

    if (searchText === "") {
      setCountryList(countryFindSuccess);
    } else {
      setCountryList((chips) =>
        chips.filter((data) =>
          data.countryName.toLowerCase().includes(searchText)
        )
      )
    }
  };

  const handleCityChange = (e) => {
    try {
      const citySearch = e.target.value.toLowerCase();
      if (citySearch) {
        const filteredArray = city.filter((value) => {
          return value.livingCity.toLowerCase().includes(citySearch)
        })
        setCity(filteredArray)
      } 
      else {
        setCity(uniqueSymbolArray)
      }

    } catch (error) {
      console.error(error);
    }
  }

  const handleCheckCountry = (event, branchId) => {
    setSelectedCountries((prevSelected) => {
      if (event.target.checked) {
        // Add to the list if checked
        return [...prevSelected, branchId];
      } else {
        // Remove from the list if unchecked
        return prevSelected.filter((id) => id !== branchId);
      }
    });
  };

  const handleCheckApplicationPaymentStatus = (event, paymentStatus) => {
    setSelectedPaymentStatus((prevSelected) => {
      if(event.target.checked) {
        return [...prevSelected, paymentStatus]
      } else {
        return prevSelected.filter((id) => id !== paymentStatus)
      }
    })
  }

  const handleCheckApplicationUniversity = (event, universityId) => {
    setSelectedUniversity((prevSelected) => {
      if(event.target.checked) {
        return [...prevSelected, universityId]
      } else {
        return prevSelected.filter((id) => id !== universityId )
      }
    })
  }

  const handleCheckApplicationStatus = (event, statusId) => {
    setSelectedApplicationStatus((prevSelected) => {
      if(event.target.checked) {
        return [...prevSelected, statusId]
      } else {
        return prevSelected.filter((id) => id !== statusId )
      }
    })
  }

  const handleCheckPreferedCountry = (event, branchId) => {
    setSelectedPreferedCountries((prevSelected) => {
      if (event.target.checked) {
        // Add to the list if checked
        return [...prevSelected, branchId];
      } else {
        // Remove from the list if unchecked
        return prevSelected.filter((id) => id !== branchId);
      }
    });
  }

  const handleStatusCheckedChange = (event, branchId) => {
    setSelectedLeadStatus((prevSelected) => {
      if (event.target.checked) {
        // Add to the list if checked
        return [...prevSelected, branchId];
      } else {
        // Remove from the list if unchecked
        return prevSelected.filter((id) => id !== branchId);
      }
    });
  }

  const handleSourceCheckChange = (event, branchId) => {
    setSelectedLeadSource((prevSelected) => {
      if (event.target.checked) {
        // Add to the list if checked
        return [...prevSelected, branchId];
      } else {
        // Remove from the list if unchecked
        return prevSelected.filter((id) => id !== branchId);
      }
    });
  }

  const handleBranchCheckChange = (event, branchId) => {
    setSelectedBranch((prevSelected) => {
      if (event.target.checked) {
        // Add to the list if checked
        return [...prevSelected, branchId];
      } else {
        // Remove from the list if unchecked
        return prevSelected.filter((id) => id !== branchId);
      }
    });
  }

  const handleDealsPaymentStatus = (event, paymentId) => {
    console.log(377, paymentId);
    
    setSelectedDealPaymentStatus((prevSelected) => {
      if (event.target.checked) {
        // Only add if it doesn't already exist
        if (!prevSelected.includes(paymentId)) {
          return [...prevSelected, paymentId];
        }
        return prevSelected; // Don't add duplicate
      } else {
        return prevSelected.filter((id) => id !== paymentId);
      }
    });
  }

  const handleChecktagsChange = (event, branchId) => {
    setSelectedTag((prevSelected) => {
      if (event.target.checked) {
        return [...prevSelected, branchId];
      } else {
        return prevSelected.filter((id) => id !== branchId);
      }
    });
  }

  const handleRegFeeCheckChange = (event, value) => {
    if (event.target.checked) {
      setSelectedRegFee(value); 
    } else {
      setSelectedRegFee("");
    }
  }

  const handleEmployeeStatusChange = (event, value) => {
    if(event.target.checked) {
      setEmployeeStatus(value)
    } else {
      setEmployeeStatus("")
    }
  }

  // role search show
  const handleStatusFilter = (status) => {
    setSelectedRole(status)
    props.LeadFilterFunction(status, "Status");
  };

  // role search show
  // const handleCheckRole = (event, branchId) => {
  //   props.LeadFilterFunction(event.target.checked, "Role Name", branchId);
  // };

  const handleCheckRole = (event, roleId) => {
    setSelectedRole((prevSelected) => {
      if (event.target.checked) {
        return [...prevSelected, roleId]
      } else {
        return prevSelected.filter((id) => id !== roleId)
      }
    })
  }

  // Role seraching
  const handleRole = (e) => {
    const searchText = e.target.value.toLowerCase();

    if (searchText === "") {
      setRoleList(allRoleFindSuccess); // Reset to the original data when search text is empty
    } else {
      setRoleList((chips) =>
        chips.filter((data) => data.roleName.toLowerCase().includes(searchText))
      );
    }
  };

  // Status :::::::::::::
  const uniqueStatuses = Array.from(
    new Set(props?.data?.map((item) => item.status))
  );

  const uniqueBranchNames = Array.from(
    new Set(
      data?.flatMap((user) =>
        (user?.user_Branches || [])
          .map((b) => b.branch_master?.branchName)
          .filter(Boolean)
      )
    )
  );

  const uniqueEmployeeRole = Array.from(
    new Set(
      data?.map((employee) => employee?.role?.roleName)
      .filter(Boolean)
    )
  )

  const uniqueApplicationStatus = Array.from(
    new Set(props?.data?.map((item) => item.methodStatus))
  );

  // Source :::::::::::::::::

  const uniqueSource = Array.from(
    new Set(
      props?.data
        ?.map((item) => item.leadSource)
        .filter((source) => source !== "" && source !== null)
    )
  );

  // Branch ::::::::::::::::::::

  const uniqueBranch = Array.from(
    new Set(
      props?.data
        ?.map((item) => item?.branch_master?.branchName)
        .filter(
          (source) => source !== "" && source !== null && source !== undefined
        )
    )
  );

  // University

  const uniqueUniversity = Array.from(
    new Set(
      props?.data
        ?.map((item) => item?.universityName)
        .filter(
          (source) => source !== "" && source !== null && source !== undefined
        )
    )
  );

  const handleRecalledDateCheck = (e) => {
    try {      
      if (Array.isArray(e) && e.length === 2) {
        const formattedDates = e.map(date =>
          date.hour(4).minute(30).second(34).format("YYYY-MM-DD HH:mm:ss")
        );
          setRecalledStatusChangeDate(formattedDates)

      } else {
        console.warn("Expected a date range array of length 2.");
      }
    } catch(error) {
      console.error(error);
    }
  }

  const MapStatus = ["Active", "Inactive"];

  return (
    <>
      <List
        sx={{
          maxWidth: "316px",
          height: "auto",
          bgcolor: "background.paper",
          borderRadius: "8px",
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          border: "1px solid #ECECEC",
          mt: 2.5
        }}
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader
            component="div"
            id="nested-list-subheader"
            sx={{ backgroundColor: "#F2F2F2" }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>Filter</div>
              <div
                style={{
                  display: "flex",
                  marginTop: "12px",
                  cursor: "pointer"
                }}
                onClick={handleClearClick}
              >
                <MdClear style={{ fontSize: "22px", height: "20px" }} />{" "}
                <Typography>Clear All</Typography>
              </div>
            </div>
          </ListSubheader>
        }
      >
        {props.statusComponent === "lead" ||
        props.statusComponent === "leadDeferral" ? (
          <>
              <ListItemButton onClick={handleClickCity}>
                <ListItemText
                  primary="City"
                  sx={{ textTransform: "capitalize" }}
                />
                {secListopen ? (
                  <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
                ) : (
                  <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
                )}
              </ListItemButton>
              <Collapse in={filterCityOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton>
                    <TextField
                      placeholder="Search Here"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton>
                              <AiOutlineSearch />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                      onChange={handleCityChange}
                      sx={{
                        backgroundColor: "white",
                        margin: 1,
                        width: "auto",
                        "& .MuiInputBase-input": {
                          borderRadius: "20px",
                          height: "1px"
                        },
                        "& .MuiFormLabel-root": {
                          lineHeight: "5px"
                        },
                        "& .MuiInputBase-root": {
                          borderRadius: "3px",
                          borderColor: "#fafafa"
                        }
                      }}
                    />
                  </ListItemButton>
                  <ListItemButton sx={{ display: 'block', padding: 0 }}>
                    <Box sx={{
                      maxHeight: '400px',
                      overflowY: 'auto',
                      padding: '0 16px',
                      '&::-webkit-scrollbar': {
                        width: '6px',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#dcdcde',
                        borderRadius: '3px',
                      },
                    }}
                    >
                      <FormGroup>
                        {city &&
                          city?.map((leadPlace, index) => (
                            <FormControlLabel
                              key={index}
                              control={
                                <Checkbox
                                  sx={{
                                    color: "#F8469A",
                                    "&.Mui-checked": {
                                      color: "#F8469A"
                                    }
                                  }}
                                  value={leadPlace?.livingCity}
                                  checked={selectedCountries.includes(leadPlace.livingCity)}
                                  onChange={(e) => {
                                    handleCheckCountry(
                                      e,
                                      leadPlace?.livingCity
                                    );
                                  }}
                                />
                              }
                              label={leadPlace?.livingCity}
                            />
                          ))}
                      </FormGroup>
                    </Box>
                  </ListItemButton>
                </List>
              </Collapse>

            <ListItemButton onClick={handleClick2}>
              <ListItemText
                primary="prefferred country"
                sx={{ textTransform: "capitalize" }}
              />
              {secListopen ? (
                <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
              ) : (
                <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
              )}
            </ListItemButton>
            <Collapse in={secListopen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton>
                  <TextField
                    placeholder="Search Here"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment>
                          <IconButton>
                            <AiOutlineSearch />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    onChange={handleChange}
                    sx={{
                      backgroundColor: "white",
                      margin: 1,
                      width: "auto",
                      "& .MuiInputBase-input": {
                        borderRadius: "20px",
                        height: "1px"
                      },
                      "& .MuiFormLabel-root": {
                        lineHeight: "5px"
                      },

                      "& .MuiInputBase-root": {
                        borderRadius: "3px",
                        borderColor: "#fafafa"
                      }
                    }}
                  />
                </ListItemButton>

                <ListItemButton>
                    <Box
                      sx={{
                        maxHeight: '400px',
                        overflowY: 'auto',
                        padding: '0 16px',
                        '&::-webkit-scrollbar': {
                          width: '6px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                          backgroundColor: '#dcdcde',
                          borderRadius: '3px',
                        },
                      }}
                    >
                  <FormGroup>
                    {countryList &&
                      countryList?.map((country) => (
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                color: "#F8469A",
                                "&.Mui-checked": {
                                  color: "#F8469A"
                                }
                              }}
                              value={country.countryName.split("(")[0]}
                              checked={selectedPreferedCountries.includes(country.countryName.split("(")[0])}
                              onChange={(e) => {
                                handleCheckPreferedCountry(
                                  e,
                                  country.countryName.split("(")[0]
                                );
                              }}
                            />
                          }
                          label={country.countryName.split("(")[0]}
                        />
                      ))}
                  </FormGroup>
                </Box>
                </ListItemButton>
              </List>
            </Collapse>
            {/* third List */}

            {statusComponent !== "leadDeferral" && component !== "dead" && component !== "recalled" && (
              <>
                <ListItemButton onClick={handleClick3}>
                  <ListItemText
                    primary="status"
                    sx={{ textTransform: "capitalize" }}
                  />
                  {thirdListopen ? (
                    <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
                  ) : (
                    <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
                  )}
                </ListItemButton>
                <Collapse in={thirdListopen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton
                      style={{
                        textAlign: "center"
                      }}
                    >
                        <Box
                          sx={{
                            maxHeight: '400px',
                            overflowY: 'auto',
                            padding: '0 16px',
                            '&::-webkit-scrollbar': {
                              width: '6px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: '#dcdcde',
                              borderRadius: '3px',
                            },
                          }}
                        >
                      
                      <FormGroup>
                        {uniqueStatuses.map((item) => {
                          return (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  sx={{
                                    color: "#F8469A",
                                    "&.Mui-checked": {
                                      color: "#F8469A"
                                    }
                                  }}
                                  value={item}
                                  checked={selectedLeadStatus.includes(item)}
                                  onChange={(event) => handleStatusCheckedChange( 
                                    event,
                                    item
                                  )}
                                />
                              }
                              label={item?.[0]?.toUpperCase() + item?.slice(1)}
                            />
                          );
                        })}
                      </FormGroup>
                      </Box>
                    </ListItemButton>
                  </List>
                </Collapse>
              </>
            )}

            {props.statusComponent == "leadDeferral" ? (
              // <>
              //   <ListItemButton onClick={handleClick4}>
              //     <ListItemText
              //       primary="next intake month"
              //       sx={{ textTransform: "capitalize" }}
              //     />
              //     {fourthListopen ? (
              //       <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
              //     ) : (
              //       <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
              //     )}
              //   </ListItemButton>
              //   <Collapse in={fourthListopen} timeout="auto" unmountOnExit>
              //     <List component="div" disablePadding>
              //       <ListItemButton>
              //         <Box sx={{ mt: 1 }}>
              //           <LocalizationProvider dateAdapter={AdapterDateFns}>
              //             <DatePicker
              //               views={["month"]}
              //               label="Month"
              //               value={intakeMonth}
              //               sx={{ width: 200 }}
              //               onChange={(newValue) => handleMonthFilter(newValue, "month")}
              //               renderInput={(params) => (
              //                 <TextField {...params} fullWidth />
              //               )}
              //             />
              //           </LocalizationProvider>
              //           {/* <Typography>{error?.intakeMonth}</Typography> */}
              //         </Box>
              //       </ListItemButton>
              //     </List>
              //   </Collapse>
              //   <ListItemButton onClick={handleClick8}>
              //     <ListItemText
              //       primary="next intake year"
              //       sx={{ textTransform: "capitalize" }}
              //     />
              //     {eightListopen ? (
              //       <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
              //     ) : (
              //       <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
              //     )}
              //   </ListItemButton>
              //   <Collapse in={eightListopen} timeout="auto" unmountOnExit>
              //     <List component="div" disablePadding>
              //       <ListItemButton>
              //         <Box sx={{ mt: 3 }}>
              //           <LocalizationProvider dateAdapter={AdapterDateFns}>
              //             <DatePicker
              //               views={["year"]}
              //               label="Year"
              //               value={intakeYear}
              //               sx={{ width: 200 }}
              //               onChange={(newValue) => handleYearFilter(newValue, "year")}
              //               renderInput={(params) => (
              //                 <TextField {...params} fullWidth />
              //               )}
              //             />
              //           </LocalizationProvider>
              //         </Box>
              //       </ListItemButton>
              //     </List>
              //   </Collapse>
              // </>
                <>
                  <DeferralFilter
                    handleClick4={handleClick4}
                    handleClick8={handleClick8}
                    fourthListopen={fourthListopen}
                    eightListopen={eightListopen}
                    intakeMonth={intakeMonth}
                    intakeYear={intakeYear}
                    handleMonthFilter={handleMonthFilter}
                    handleYearFilter={handleYearFilter}
                  />
                </>
            ) : (
              ""
            )}
          
            <ListItemButton onClick={handleClick5}>
              <ListItemText
                primary="source"
                sx={{ textTransform: "capitalize" }}
              />
              {fifthListopen ? (
                <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
              ) : (
                <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
              )}
            </ListItemButton>
            {/* collapse */}
            <Collapse in={fifthListopen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton>
                <Box sx={{
                      maxHeight: '400px',
                      overflowY: 'auto',
                      padding: '0 16px',
                      '&::-webkit-scrollbar': {
                        width: '6px',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#dcdcde',
                        borderRadius: '3px',
                      },
                    }}
                    >
                  <FormGroup>
                    {uniqueSource?.map((item) => {
                      return (
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                color: "#F8469A",
                                "&.Mui-checked": {
                                  color: "#F8469A"
                                }
                              }}
                              value={item}
                              checked={selectedLeadSource.includes(item)}
                              onChange={(e) => handleSourceCheckChange(e, item)}
                            />
                          }
                          label={item}
                        />
                      );
                    })}
                  
                  </FormGroup>
                  </Box>
                </ListItemButton>
              </List>
            </Collapse>
            {/* sixth List */}
            <ListItemButton onClick={handleClick6}>
              <ListItemText
                primary="branch"
                sx={{ textTransform: "capitalize" }}
              />
              {sixthListopen ? (
                <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
              ) : (
                <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
              )}
            </ListItemButton>
            {/* collapse */}
            <Collapse in={sixthListopen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton>
                <Box sx={{
                      maxHeight: '400px',
                      overflowY: 'auto',
                      padding: '0 16px',
                      '&::-webkit-scrollbar': {
                        width: '6px',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#dcdcde',
                        borderRadius: '3px',
                      },
                    }}
                    >
                  <FormGroup>
                    {uniqueBranch?.map((item) => {
                      return (
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                color: "#F8469A",
                                "&.Mui-checked": {
                                  color: "#F8469A"
                                }
                              }}
                              value={item}
                              checked={selectedBranch.includes(item)}
                              onChange={(e) => handleBranchCheckChange(e, item)}
                            />
                          }
                          label={item}
                        />
                      );
                    })}
                  </FormGroup>
                  </Box>
                </ListItemButton>
              </List>
            </Collapse>
            {/* sixth List */}
            <ListItemButton onClick={handleClick7}>
              <ListItemText
                primary="Tags"
                sx={{ textTransform: "capitalize" }}
              />
              {sevenListopen ? (
                <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
              ) : (
                <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
              )}
            </ListItemButton>
            {/* collapse */}
            <Collapse in={sevenListopen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: "#F8469A",
                            "&.Mui-checked": {
                              color: "#F8469A"
                            }
                          }}
                          checked={selectedTag.includes("Duplicate")}
                          value={"Duplicate"}
                          onChange={(e) => handleChecktagsChange(e, "Duplicate")}
                        />
                      }
                      label={"Duplicate"}
                    />
                  </FormGroup>
                </ListItemButton>
                <ListItemButton>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: "#F8469A",
                            "&.Mui-checked": {
                              color: "#F8469A"
                            }
                          }}
                          checked={selectedTag.includes("Registration fee approval")}
                          value={"Registration fee approval"}
                          onChange={(e) => handleChecktagsChange(e, "Registration fee approval")}
                        />
                      }
                      label={"Registration fee approval"}
                    />
                  </FormGroup>
                </ListItemButton>

                <ListItemButton>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: "#F8469A",
                            "&.Mui-checked": {
                              color: "#F8469A"
                            }
                          }}
                          checked={selectedTag.includes("Recalled")}
                          value={"Recalled"}
                          onChange={(e) => handleChecktagsChange(e, "Recalled")}
                        />
                      }
                      label={"Recalled"}
                    />
                  </FormGroup>
                </ListItemButton>

                <ListItemButton>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: "#F8469A",
                            "&.Mui-checked": {
                              color: "#F8469A"
                            }
                          }}
                          checked={selectedTag.includes("Tuition fee approval")}
                          value={"Tuition fee approval"}
                          onChange={(e) => handleChecktagsChange(e, "Tuition fee approval")}
                        />
                      }
                      label={"Tuition fee approval"}
                    />
                  </FormGroup>
                </ListItemButton>

                  {component !== "lead" && (
                    <ListItemButton>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                color: "#F8469A",
                                "&.Mui-checked": {
                                  color: "#F8469A"
                                }
                              }}
                              checked={selectedTag.includes("status approval")}
                              value={"status approval"}
                              onChange={(e) => handleChecktagsChange(e, "status approval")}
                            />
                          }
                          label={"status approval"}
                        />
                      </FormGroup>
                    </ListItemButton>
                  )}

                <ListItemButton>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: "#F8469A",
                            "&.Mui-checked": {
                              color: "#F8469A"
                            }
                          }}
                          checked={selectedTag.includes("owner change approval")}
                          value={"owner change approval"}
                          onChange={(e) => handleChecktagsChange(e, "owner change approval")}
                        />
                      }
                      label={"owner change approval"}
                    />
                  </FormGroup>
                </ListItemButton>

                <ListItemButton>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: "#F8469A",
                            "&.Mui-checked": {
                              color: "#F8469A"
                            }
                          }}
                          checked={selectedTag.includes("source approval")}
                          value={"source approval"}
                          onChange={(e) => handleChecktagsChange(e, "source approval")}
                        />
                      }
                      label={"source approval"}
                    />
                  </FormGroup>
                </ListItemButton>

                <ListItemButton>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: "#F8469A",
                            "&.Mui-checked": {
                              color: "#F8469A"
                            }
                          }}
                          checked={selectedTag.includes("Enrollment Approval")}
                          value={"Enrollment Approval"}
                          onChange={(e) => handleChecktagsChange(e, "Enrollment Approval")}
                        />
                      }
                      label={"Enrollment Approval"}
                    />
                  </FormGroup>
                </ListItemButton>

                <ListItemButton>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: "#F8469A",
                            "&.Mui-checked": {
                              color: "#F8469A"
                            }
                          }}
                          checked={selectedTag.includes("email change approval")}
                          value={"email change approval"}
                          onChange={(e) => handleChecktagsChange(e, "email change approval")}
                        />
                      }
                      label={"email change approval"}
                    />
                  </FormGroup>
                </ListItemButton>

                <ListItemButton>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: "#F8469A",
                            "&.Mui-checked": {
                              color: "#F8469A"
                            }
                          }}
                          checked={selectedTag.includes("mobile change approval")}
                          value={"mobile change approval"}
                          onChange={(e) => handleChecktagsChange(e, "mobile change approval")}
                        />
                      }
                      label={"mobile change approval"}
                    />
                  </FormGroup>
                </ListItemButton>


                <ListItemButton>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: "#F8469A",
                            "&.Mui-checked": {
                              color: "#F8469A"
                            }
                          }}
                          checked={selectedTag.includes("Doc approval")}
                          value={"Doc approval"}
                          onChange={(e) => handleChecktagsChange(e, "Doc approval")}
                        />
                      }
                      label={"Doc approval"}
                    />
                  </FormGroup>
                </ListItemButton>


                <ListItemButton>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: "#F8469A",
                            "&.Mui-checked": {
                              color: "#F8469A"
                            }
                          }}
                          checked={selectedTag.includes("Passport verification")}
                          value={"Passport verification"}
                          onChange={(e) => handleChecktagsChange(e, "Passport verification")}
                        />
                      }
                      label={"Passport verification"}
                    />
                  </FormGroup>
                </ListItemButton>


                <ListItemButton>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: "#F8469A",
                            "&.Mui-checked": {
                              color: "#F8469A"
                            }
                          }}
                          checked={selectedTag.includes("Passport Edit")}
                          value={"Passport Edit"}
                          onChange={(e) => handleChecktagsChange(e, "Passport Edit")}
                        />
                      }
                      label={"Passport Edit"}
                    />
                  </FormGroup>
                </ListItemButton>
              </List>
            </Collapse>

              {props.component === "recalled" || props.component === "deals" && (
                <>
                  <ListItemButton onClick={handleClickRecalledPaymentStatus}>
                    <ListItemText primary= {props.component === "recalled" ? "Recalled Date" : "Tuition Fee Date"}/>
                    {openRecalledPaymentDate ? (
                      <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
                    ) : (
                      <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
                    )}
                  </ListItemButton>
                  <Collapse in={openRecalledPaymentDate} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItemButton
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          gap: 2
                        }}
                      >
                        <Space direction="vertical" size={12}>
                          <RangePicker
                            onChange={(e) => {
                              handleRecalledDateCheck(e);
                            }}
                            allowClear={false}
                          />
                        </Space>
                      </ListItemButton>
                    </List>
                  </Collapse>
                </>
              )}

            {props.component === "lead" && (
              <>
              <ListItemButton onClick={handleClickRefistrationFee}>
                <ListItemText primary="Registration Fee" sx={{ textTransform: "capitalize" }} />
                {secListopen ? (
                  <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
                ) : (
                  <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
                )}
              </ListItemButton>
              <Collapse in={feeOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton sx={{ display: "block", padding: 0 }}>
                    <Box
                      sx={{
                        maxHeight: "600px",
                        overflowY: "auto",
                        padding: "0 16px",
                        "&::-webkit-scrollbar": {
                          width: "6px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "#dcdcde",
                          borderRadius: "3px",
                        },
                      }}
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                color: "#F8469A",
                                "&.Mui-checked": {
                                  color: "#F8469A",
                                },
                              }}
                              checked={selectedRegFee === "Paid"}
                              onChange={(e) => handleRegFeeCheckChange(e, "Paid")}
                            />
                          }
                          label={"Paid"}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                color: "#F8469A",
                                "&.Mui-checked": {
                                  color: "#F8469A",
                                },
                              }}
                              checked={selectedRegFee === "Unpaid"}
                              onChange={(e) => handleRegFeeCheckChange(e, "Unpaid")}
                            />
                          }
                          label={"Unpaid"}
                        />
                      </FormGroup>
                    </Box>
                  </ListItemButton>
                </List>
              </Collapse>
              </>
              )}

           

            {props.component === "deals" && (
              <>
                {/* Payment Status List */}
                <ListItemButton onClick={handleClick8}>
                  <ListItemText
                    primary="Payment status"
                    sx={{ textTransform: "capitalize" }}
                  />
                  {eightListopen ? (
                    <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
                  ) : (
                    <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
                  )}
                </ListItemButton>

                {/* Collapse for Payment Status */}
                <Collapse in={eightListopen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton>
                      <FormGroup>
                        {dealsPaymentStatus?.map((value) => (
                          <>
                          <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                color: "#F8469A",
                                "&.Mui-checked": { color: "#F8469A" }
                              }}
                              checked={selectedPaymentStaus.includes(value)}
                              value={selectedPaymentStaus}
                              onChange={(e) => {
                                handleDealsPaymentStatus(e, value);
                              }}
                            />
                          }
                          label={value}
                        />
                          </>
                        ))}
{/*                         
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                color: "#F8469A",
                                "&.Mui-checked": { color: "#F8469A" }
                              }}
                              value="Completed"
                              onChange={(e) => {
                                props.LeadFilterFunction(
                                  e.target.value,
                                  "paymentStatus",
                                  e.target.checked
                                );
                              }}
                            />
                          }
                          label="Completed"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                color: "#F8469A",
                                "&.Mui-checked": { color: "#F8469A" }
                              }}
                              value="Refund Credited"
                              onChange={(e) => {
                                props.LeadFilterFunction(
                                  e.target.value,
                                  "refund",
                                  e.target.checked
                                );
                              }}
                            />
                          }
                          label="Refunded"
                        /> */}
                      </FormGroup>
                    </ListItemButton>
                  </List>
                </Collapse>
              </>
            )}
          </>
        ) : (
          ""
        )}

        {props.statusComponent === "employee" && (
          <>
            {/* first List */}
            <ListItemButton onClick={handleClick6}>
              <ListItemText
                primary="branch"
                sx={{ textTransform: "capitalize" }}
              />
              {sixthListopen ? (
                <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
              ) : (
                <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
              )}
            </ListItemButton>
            {/* collapse */}
            <Collapse in={sixthListopen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton>
                <Box sx={{
                      maxHeight: '400px',
                      overflowY: 'auto',
                      padding: '0 16px',
                      '&::-webkit-scrollbar': {
                        width: '6px',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#dcdcde',
                        borderRadius: '3px',
                      },
                    }}
                    >
                  <FormGroup>
                    {uniqueBranchNames?.map((item) => {
                      return (
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                color: "#F8469A",
                                "&.Mui-checked": {
                                  color: "#F8469A"
                                }
                              }}
                              value={item}
                              checked={selectedBranch.includes(item)}
                              onChange={(e) => handleBranchCheckChange(e, item)}
                            />
                          }
                          label={item}
                        />
                      );
                    })}
                  </FormGroup>
                  </Box>
                </ListItemButton>
              </List>
            </Collapse>

            {/* second List */}
            <ListItemButton onClick={handleClick2}>
              <ListItemText
                primary="Role"
                sx={{ textTransform: "capitalize" }}
              />
              {secListopen ? (
                <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
              ) : (
                <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
              )}
            </ListItemButton>

            <Collapse in={secListopen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton>
                  <TextField
                    placeholder="Search Here"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment>
                          <IconButton>
                            <AiOutlineSearch />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    sx={{
                      backgroundColor: "white",
                      margin: 1,
                      width: "auto",
                      "& .MuiInputBase-input": {
                        borderRadius: "20px",
                        height: "1px"
                      },
                      "& .MuiFormLabel-root": {
                        lineHeight: "5px"
                      },

                      "& .MuiInputBase-root": {
                        borderRadius: "3px",
                        borderColor: "#fafafa"
                      }
                    }}
                    onChange={handleRole}
                  />
                </ListItemButton>

                <ListItemButton>
                  <FormGroup>
                    {uniqueEmployeeRole &&
                      uniqueEmployeeRole?.map((role) => (
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                color: "#F8469A",
                                "&.Mui-checked": {
                                  color: "#F8469A"
                                }
                              }}
                              value={role}
                              checked={selectedRole.includes(role)}
                              onChange={(e) => handleCheckRole(e, role)}
                            />
                          }
                          label={role}
                        />
                      ))}
                  </FormGroup>
                </ListItemButton>
              </List>
            </Collapse>

            {/* thirsd List */}
            <ListItemButton onClick={handleClick3}>
              <ListItemText
                primary="Status"
                sx={{ textTransform: "capitalize" }}
              />
              {secListopen ? (
                <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
              ) : (
                <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
              )}
            </ListItemButton>

            {/* <Collapse in={thirdListopen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton>
                  <FormGroup>
                    {MapStatus &&
                      MapStatus?.map((role) => (
                        <FormControlLabel
                          control={
                            <Checkbox
                            checked={selectedRole === role}
                              sx={{
                                color: "#F8469A",
                                "&.Mui-checked": {
                                  color: "#F8469A"
                                }
                              }}
                              onChange={() => {
                                handleStatusFilter(role);
                              }}
                            />
                          }
                          label={role}
                        />
                      ))}
                  </FormGroup>
                </ListItemButton>
              </List>
            </Collapse> */}

            <Collapse in={thirdListopen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton sx={{ display: "block", padding: 0 }}>
                  <Box
                    sx={{
                      maxHeight: "600px",
                      overflowY: "auto",
                      padding: "0 16px",
                      "&::-webkit-scrollbar": {
                        width: "6px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#dcdcde",
                        borderRadius: "3px",
                      },
                    }}
                  >
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            sx={{
                              color: "#F8469A",
                              "&.Mui-checked": {
                                color: "#F8469A",
                              },
                            }}
                            checked={employeeStatus === "Active"}
                            onChange={(e) => handleEmployeeStatusChange(e, "Active")}
                          />
                        }
                        label={"Active"}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            sx={{
                              color: "#F8469A",
                              "&.Mui-checked": {
                                color: "#F8469A",
                              },
                            }}
                            checked={employeeStatus === "Inactive"}
                            onChange={(e) => handleEmployeeStatusChange(e, "Inactive")}
                          />
                        }
                        label={"Inactive"}
                      />
                    </FormGroup>
                  </Box>
                </ListItemButton>
              </List>
            </Collapse>
          </>
        )}

        {props.statusComponent === "leadApplication" && (
          <>
            <ListItemButton onClick={handleClick2}>
              <ListItemText
                primary="Country"
                sx={{ textTransform: "capitalize" }}
              />
              {secListopen ? (
                <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
              ) : (
                <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
              )}
            </ListItemButton>
            <Collapse in={secListopen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton>
                  <TextField
                    placeholder="Search Here"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment>
                          <IconButton>
                            <AiOutlineSearch />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    onChange={handleChange}
                    sx={{
                      backgroundColor: "white",
                      margin: 1,
                      width: "auto",
                      "& .MuiInputBase-input": {
                        borderRadius: "20px",
                        height: "1px"
                      },
                      "& .MuiFormLabel-root": {
                        lineHeight: "5px"
                      },

                      "& .MuiInputBase-root": {
                        borderRadius: "3px",
                        borderColor: "#fafafa"
                      }
                    }}
                  />
                </ListItemButton>

                <ListItemButton>
                  <FormGroup>
                    {countryList &&
                      countryList?.map((country) => (
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                color: "#F8469A",
                                "&.Mui-checked": {
                                  color: "#F8469A"
                                }
                              }}
                              value={country?.countryName.split("(")[0]}
                              checked={selectedCountries.includes(country?.countryName.split("(")[0])}
                              onChange={(e) => {
                                handleCheckCountry(
                                  e,
                                  country?.countryName.split("(")[0]
                                );
                              }}
                            />
                          }
                          label={country?.countryName.split("(")[0]}
                        />
                      ))}
                  </FormGroup>
                </ListItemButton>
              </List>
            </Collapse>
            <ListItemButton onClick={handleClick3}>
              <ListItemText
                primary="status"
                sx={{ textTransform: "capitalize" }}
              />
              {thirdListopen ? (
                <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
              ) : (
                <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
              )}
            </ListItemButton>
            <Collapse in={thirdListopen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  style={{
                    textAlign: "center"
                  }}
                >
                  <FormGroup>
                    {uniqueApplicationStatus?.map((item) => {
                      return (
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                color: "#F8469A",
                                "&.Mui-checked": {
                                  color: "#F8469A"
                                }
                              }}
                              // value={item}
                              // onChange={(e) => {
                              //   props.LeadFilterFunction(
                              //     e.target.value,
                              //     "leadStatus",
                              //     e.target.checked
                              //   );
                              // }}
                              value={ item } 
                              checked={selectedApplicationStatus.includes(item)}
                              onChange={(e) => { handleCheckApplicationStatus(e,item) }}
                            />
                          }
                          label={item}
                        />
                      );
                    })}
                  </FormGroup>
                </ListItemButton>
              </List>
            </Collapse>
            <ListItemButton onClick={handleUniversityOpen}>
              <ListItemText
                primary="University"
                sx={{ textTransform: "capitalize" }}
              />
              {universityOpen ? (
                <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
              ) : (
                <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
              )}
            </ListItemButton>
            <Collapse in={universityOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  style={{
                    textAlign: "center"
                  }}
                >
                  <FormGroup>
                    {uniqueUniversity.map((item) => {
                      return (
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                color: "#F8469A",
                                "&.Mui-checked": {
                                  color: "#F8469A"
                                }
                              }}
                              // value={item}
                              // onChange={(e) => {
                              //   props.LeadFilterFunction(
                              //     e.target.value,
                              //     "leadUniversity",
                              //     e.target.checked
                              //   );
                              // }}
                              value={ item } 
                              checked={selectedUniversity.includes(item)}
                              onChange={(e) => { handleCheckApplicationUniversity(e,item) }}
                            />
                          }
                          label={item}
                        />
                      );
                    })}
                  </FormGroup>
                </ListItemButton>
              </List>
            </Collapse>
            <ListItemButton onClick={handleClick4}>
              <ListItemText
                primary="next intake month"
                sx={{ textTransform: "capitalize" }}
              />
              {fourthListopen ? (
                <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
              ) : (
                <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
              )}
            </ListItemButton>
            <Collapse in={fourthListopen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton>
                  <Box sx={{ mt: 1 }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        views={["month"]}
                        label="Month"
                        value={intakeMonth}
                        sx={{ width: 200 }}
                        onChange={(newValue) =>
                          handleMonthFilter(newValue, "month")
                        }
                        renderInput={(params) => (
                          <TextField {...params} fullWidth />
                        )}
                      />
                    </LocalizationProvider>
                    {/* <Typography>{error?.intakeMonth}</Typography> */}
                  </Box>
                </ListItemButton>
              </List>
            </Collapse>
            <ListItemButton onClick={handleClick8}>
              <ListItemText
                primary="next intake year"
                sx={{ textTransform: "capitalize" }}
              />
              {eightListopen ? (
                <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
              ) : (
                <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
              )}
            </ListItemButton>
            <Collapse in={eightListopen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton>
                  <Box sx={{ mt: 3 }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        views={["year"]}
                        label="Year"
                        value={intakeYear}
                        // minDate={new Date()} // Restricts to the current year and future years
                        sx={{ width: 200 }}
                        onChange={(newValue) =>
                          handleYearFilter(newValue, "year")
                        }
                        renderInput={(params) => (
                          <TextField {...params} fullWidth />
                        )}
                      />
                    </LocalizationProvider>
                  </Box>
                </ListItemButton>
              </List>
            </Collapse>
            <ListItemButton onClick={handleClick5}>
              <ListItemText
                primary="Payment Status"
                sx={{ textTransform: "capitalize" }}
              />
              {eightListopen ? (
                <ExpandLess sx={{ fontSize: "17px", fontWeight: "thin" }} />
              ) : (
                <ExpandMore sx={{ fontSize: "17px", fontWeight: "thin" }} />
              )}
            </ListItemButton>
            <Collapse in={fifthListopen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton>
                  <Box sx={{ mt: 3, display: "flex", flexDirection: "column" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: "#F8469A",
                            "&.Mui-checked": {
                              color: "#F8469A"
                            }
                          }}
                          // value={"Completed"}
                          // onChange={(e) => {
                          //   props.LeadFilterFunction(
                          //     e.target.value,
                          //     "paymentStatus",
                          //     e.target.checked
                          //   );
                          // }}
                          value={"Completed"}
                          checked={selectedPaymentStatus.includes("completed")}
                          onChange={(e) => { handleCheckApplicationPaymentStatus(e, "completed") }}
                        />
                      }
                      label={"Completed"}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            color: "#F8469A",
                            "&.Mui-checked": {
                              color: "#F8469A"
                            }
                          }}
                          // value={"Deposit"}
                          // onChange={(e) => {
                          //   props.LeadFilterFunction(
                          //     e.target.value,
                          //     "paymentStatus",
                          //     e.target.checked
                          //   );
                          // }}
                          value={"Deposit"}
                          checked={selectedPaymentStatus.includes("deposite")}
                          onChange={(e) => { handleCheckApplicationPaymentStatus(e,"deposite") }}
                        />
                      }
                      label={"Deposit"}
                    />

                    {props.component == "deals" ||
                      props.component == "application" ?(
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                color: "#F8469A",
                                "&.Mui-checked": {
                                  color: "#F8469A"
                                }
                              }}
                              // value={"Refund Credited"}
                              // onChange={(e) => {
                              //   props.LeadFilterFunction(
                              //     e.target.value,
                              //     "refund",
                              //     e.target.checked
                              //   );
                              //   //   return updatedSource;
                              //   // });
                              // }}
                              value={"Refund Credited"}
                              checked={selectedPaymentStatus.includes("Refund Credited")}
                              onChange={(e) => { handleCheckApplicationPaymentStatus(e,"Refund Credited") }}
                            />
                          }
                          label={"Refund"}
                        />
                      ):""}
                  </Box>
                </ListItemButton>
              </List>
            </Collapse>
          </>
        )}
      </List>

      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          const inputValue = e.target.elements[0].value;
          // Call the handler function with the event
          props.handlePaginationEntry({ target: { value: inputValue } });
        }}
        sx={{
          display: "flex",
          gap: "10px",
          mt: "29px",
          alignItems: "center",
          "& input": {
            border: "1px solid #B8BECC",
            borderRadius: "4px",
            outline: "none",
            maxWidth: "80px",
            textAlign: "center",
            fontSize: "16px",
            lineHeight: "24px",
            padding: "5px 17px"
          }
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            lineHeight: "19px"
          }}
        >
          Showing Entries
        </Typography>
        <input
          type="number"
          defaultValue={props.pagiantionEntry}
        // onChange={(e) => props.handlePaginationEntry(e)}
        />
        <input type="submit" style={{ display: "none" }} />
      </Box>
    </>
  );
}

export default LeadsFilterSearch;
